module.exports = __webpack_public_path__ + "img/bg-oval.49de01dc.svg";